<template>
  <div>

    <div class="topbar-especial d-flex" ref="top_menu">
			<a href="#" class="logo"></a>
      <a class="d-block d-md-none menu-sound-btn" v-if="!audioStatus" @click="activeAudio()"><font-awesome-icon icon="volume-up" class="iconos-redes" /></a>
      <a class="d-block d-md-none menu-sound-btn" v-if="audioStatus" @click="activeAudio()"><font-awesome-icon icon="volume-mute" class="iconos-redes" /></a>
      <a @click="showNav()" class="d-block d-md-none menu-nav-btn">
        <font-awesome-icon icon="bars" class="iconos-redes" />
      </a>
      <div class="controls-panel d-none d-md-block">
        <div>
          <ul>
            <li v-if="$route.name == `story`">
              <RouterLink :to="{ name: 'list'}">
                <font-awesome-icon icon="chevron-left" class="iconos-redes" />
              </RouterLink>
            </li>
            <li>              
              <a @click="showNav()"><font-awesome-icon icon="bars" class="iconos-redes" /></a>
            </li>
            <li>
              <a v-if="!audioStatus" @click="activeAudio()"><font-awesome-icon icon="volume-mute" class="iconos-redes" /></a>
              <a v-if="audioStatus" @click="activeAudio()"><font-awesome-icon icon="volume-up" class="iconos-redes" /></a>
            </li>
          </ul>
        </div>
      </div>
			<div class="languages-links d-none d-md-block" v-if="$route.name == 'list'">
				<ul>
					<li><RouterLink :to="{ name: 'list', params: { locale: 'es' }  }">
						Es
					</RouterLink></li>
					<li><RouterLink :to="{ name: 'list', params: { locale: 'en' }  }">
						En
					</RouterLink></li>
					<li><RouterLink :to="{ name: 'list', params: { locale: 'pt' }  }">
						Pt
					</RouterLink></li>
				</ul>
			</div>
			<div class="languages-links d-none d-md-block" v-if="$route.name == 'story'">
				<ul>
					<li><RouterLink :to="{ name: 'story', params: { locale: 'es', url: `${$route.params.url}` }}">
						Es
					</RouterLink></li>
					<li><RouterLink :to="{ name: 'story', params: { locale: 'en', url: `${$route.params.url}` }}">
						En
					</RouterLink></li>
					<li><RouterLink :to="{ name: 'story', params: { locale: 'pt', url: `${$route.params.url}` }}">
						Pt
					</RouterLink></li>
				</ul>
			</div>
		</div>

		<div class="scrolldown-container">
			<a href="#"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" class="bi bi-chevron-compact-down" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"/>
      </svg></a>
		</div>

    <div>
      <audio ref="audio_ambiente" src="../assets/ambiente.mp3"
       autoplay>
        Your browser does not support the <code>audio</code> element.
      </audio>
    </div>
  
    <Navigation ref="lateral_nav" />

    <router-view name="default"></router-view>

    <transition name="fade" mode="in-out" :duration="500">
      <router-view :content="contentStory" class="full-story" name="story"></router-view>
    </transition>

  </div>
</template>

<style lang="scss">

  .topbar-especial {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    background: transparent;
    z-index: 9999;
    transition: top 0.33s ease-in-out;

    &.active_nav {
      top: -65px;
    }
  }

  .menu-sound-btn {
    height: 35px;
    margin-top: 5px;
    margin-right: 15px;
    border: solid 1px rgba(255, 255, 255, 0.438);

    svg {
      margin: 5px 5px 5px 7px;
      font-size: 23px;
    }
  }

  .menu-nav-btn {
    height: 35px;
    width: 35px;
    margin-top: 5px;
    margin-right: 15px;
    border: solid 1px rgba(255, 255, 255, 0.438);

    svg {
      margin: 5px 5px 5px 7px;
      font-size: 23px;
    }
  }

  .fade-enter {
    opacity: 0;
    background-color: #000;
  }

  .fade-enter-active {
    transition: opacity .15s ease;
    background-color: #000;
  }

  .fade-leave {
    transition: opacity .15s ease;
    opacity: 0;
  }

  .fade-leave-active {
    transition: opacity .15s ease;
    opacity: 0;
  }
</style>

<script>

import i18n from '@/mixins/i18n'
import utils from '@/mixins/utils'
import Navigation from '../components/Navigation'

export default {
  name: 'App',
  mixins: [i18n, utils],
	components: {
    Navigation
  },
  data() {
    return {
      audioStatus: false
    }
  },
  beforeMount() {
    if(this.$route.params.locale) { 
      this.setLocale(this.$route.params.locale)
    } else {
      this.setLocale(this.$i18n.locale)
    } 
  },
  beforeRouteUpdate (to, from, next) {
    if(from.params.locale != to.params.locale) {
      this.setLocale(to.params.locale)
    } else {
      this.setLocale(from.params.locale)
    }
    next()
  },
  computed: {
    contentStory() {
      if(this.$route.params.url)
        return this.$i18n.messages[this.$i18n.locale].stories[this.$route.params.url]
      return {}
    }
  },
  methods: {
    activeAudio() {
      this.audioStatus = !this.audioStatus

      if(this.audioStatus) {
        this.$refs['audio_ambiente'].play()
      }
      else {
        this.$refs['audio_ambiente'].pause()
      }
    },
    showNav() {
      document.querySelector(`.navigation_stories`).classList.add('active_nav')
      document.querySelector(`.topbar-especial`).classList.add('active_nav')
    }
  }

}
</script>

<style lang="scss">
  @import '../assets/style.scss';
</style>